import { render, staticRenderFns } from "./popup-chanxian-list.vue?vue&type=template&id=0238c266&scoped=true"
import script from "./popup-chanxian-list.vue?vue&type=script&lang=js"
export * from "./popup-chanxian-list.vue?vue&type=script&lang=js"
import style0 from "./popup-chanxian-list.vue?vue&type=style&index=0&id=0238c266&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0238c266",
  null
  
)

export default component.exports